export default __webpack_public_path__ + "static/media/document-right-hover.387f39da.svg";